import {
  Alert,
  Box,
  Chip,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from "@mui/material";
import { useState } from "react";
import {
  analisarXml,
  competenciaExibicao,
  cpfExibicao,
  moeda,
  TOTALIZADORES
} from "../../shared/apresentacaoEvento";
import { Abas, Campo, Codigo } from "./Elementos";

export function XmlResultado({ xml }) {
  const { campos, erro } = analisarXml(xml);
  const valores = campos.filter((c) => c.monetario);
  if (erro) return <Alert severity="warning">{erro}</Alert>;
  return (
    <Abas
      label="Conteúdo do retorno"
      secoes={[
        {
          id: "valores-xml",
          label: `Valores (${valores.length})`,
          icon: "payments",
          content: (
            <>
              {valores.length ? (
                <>
                  <Alert severity="info" sx={{ mb: 2 }}>
                    Bases, tributos e totais são apresentados separadamente. Os
                    níveis do XML não devem ser somados entre si.
                  </Alert>
                  <TabelaCampos campos={valores} />
                </>
              ) : (
                <Alert severity="info">
                  Este retorno não contém campos monetários.
                </Alert>
              )}
            </>
          )
        },
        {
          id: "informacoes-xml",
          label: "Informações",
          icon: "list_alt",
          content: <TabelaCampos campos={campos.filter((c) => !c.monetario)} />
        },
        {
          id: "xml-original",
          label: "XML original",
          icon: "code",
          content: <Codigo>{xml}</Codigo>
        }
      ]}
    />
  );
}
function TabelaCampos({ campos }) {
  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Informação / grupo de origem</TableCell>
            <TableCell align="right">Valor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {campos.map((c, i) => (
            <TableRow key={i}>
              <TableCell sx={{ maxWidth: 650, overflowWrap: "anywhere" }}>
                <Typography fontWeight={600}>{c.rotulo}</Typography>
                {c.contexto && (
                  <Typography variant="body2">{c.contexto}</Typography>
                )}
                <Typography variant="caption" color="text.secondary">
                  {c.caminho}
                </Typography>
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  whiteSpace: c.monetario ? "nowrap" : "normal",
                  fontVariantNumeric: "tabular-nums",
                  overflowWrap: "anywhere"
                }}
              >
                {c.monetario && Number.isFinite(Number(c.valor))
                  ? moeda(c.valor)
                  : c.valor}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
export default function Totalizadores({ items = [] }) {
  const [selecionado, setSelecionado] = useState("");
  if (!items.length)
    return (
      <Alert severity="info">
        Nenhum totalizador local associado a este evento. Consulte a recuperação
        em Ferramentas quando houver retorno faltante.
      </Alert>
    );
  const atual =
    items.find((t, i) => String(t.id ?? i) === selecionado) || items[0];
  return (
    <Stack spacing={2}>
      <TextField
        select
        fullWidth
        label="Totalizador"
        value={String(atual.id ?? items.indexOf(atual))}
        onChange={(e) => setSelecionado(e.target.value)}
      >
        {items.map((t, i) => (
          <MenuItem key={t.id ?? i} value={String(t.id ?? i)}>
            S-{String(t.tipo).replace(/^S/, "")} ·{" "}
            {TOTALIZADORES[String(t.tipo).replace(/^S/, "")] || "Totalizador"} ·
            #{t.id ?? i + 1}
          </MenuItem>
        ))}
      </TextField>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={3}>
        <Campo
          label="Competência"
          value={competenciaExibicao(atual.perApuracao)}
        />
        <Campo label="CPF" value={cpfExibicao(atual.cpfTrabalhador)} />
        <Campo label="Recibo de origem" value={atual.nrReciboArquivoBase} />
      </Stack>
      <Box>
        <Chip
          size="small"
          variant="outlined"
          color="primary"
          label="Retorno armazenado no conector"
        />
      </Box>
      <XmlResultado xml={atual.xmlEventoTotalizador} />
    </Stack>
  );
}
